import qs from "qs";
import {browser} from "$app/environment";
import {JwtStore} from "$lib/stores";
import axios from "axios";
import {PUBLIC_API_URL, PUBLIC_TOKEN} from "$env/static/public";
import getHttpError from '$lib/helpers/getHttpError';

/*
  Чтобы не дублировать код получения и вставки jwt в header запросов
  подготавливаем тут методы-обертки для axios.get/axios.post/axios.put/axios.delete
  с заданными header-ом и сериализованными параметрами для гет ?filter[field]=value
 */
/**
 *
 * @param userToken
 * @param verify - проверять или нет наличие токена, для апи accounting не проверяем
 */
export default function apiHelper(userToken?: string, verify = true) {
  let JwtToken: string | null = null;
  // если рендерим на сервере - токен обязателен
  if (!browser && !userToken && verify) {
    JwtToken = PUBLIC_TOKEN;
    //throw new Error("User JWT token is required for server-side usage");
  }



  // если рендерим на клиенте - получим токен из стора
  if (browser && !userToken) {
    JwtStore.subscribe((_token) => {
      JwtToken = _token;
    });
  }

  if (!browser) {
    JwtToken = userToken as string;
  }

  // если нет токена - используем публичный
  if (!JwtToken) {
    JwtToken = PUBLIC_TOKEN;
  }

  /*
    В нашем апи часто используются вложенные параметры, типа filter[filed]=value
    для упрощения работы - добавим поддержку работы с ними, можно передать в апи просто обьект
    filter: { field: value }
  */
  const serializer = function (params: any) {
    return qs.stringify(params, { encodeValuesOnly: true });
  }

  // создаем добавляем авторизовочный заголовок
  const authHeader = {'Authorization': `Bearer ${JwtToken}`};

  /**
   *  @param {string} apiUrl название api - без префикса / и без "api"
   */
  const get = async function (apiUrl: string, params: any = {}, header = {}): Promise<{
    err?: string,
    data?: any,
    meta?: any,
  }> {
    try {
      const {data} = await axios.get(`${PUBLIC_API_URL}/${apiUrl}`, {
        params,
        paramsSerializer: serializer,
        headers: {
          ...authHeader,
          ...header
        }
      });

      if (data.error) {
        return {err: data.error}
      }

      return {data};
    } catch (err: any) {
      return getHttpError(err);
    }
  }

  /**
   *  @param {string} apiUrl название api - без префикса / и без "api"
   */
  const post = async function (apiUrl: string, params: any): Promise<{
    err?: string,
    data?: any
  }> {
    try {
      const {data} = await axios.post(`${PUBLIC_API_URL}/${apiUrl}`, params, {
        paramsSerializer: serializer,
        headers: {
          ...authHeader
        }
      })

      if (data.error) {
        return {err: data.error}
      }

      return {data};
    } catch (err: any) {
      return getHttpError(err);
    }
  }

  /**
   * Вариант Post + multipart/form-data
   * @param apiUrl
   * @param formData
   */
  const postFormData = async function (apiUrl: string, formData: FormData): Promise<{
    err?: string,
    data?: any
  }> {
    try {
      const {data} = await axios.post(`${PUBLIC_API_URL}/${apiUrl}`, formData, {
        headers: {
          ...authHeader,
          "Content-Type": "multipart/form-data"
        }
      })

      if (data.error) {
        return {err: data.error}
      }

      return {data}
    } catch (err: any) {
      return getHttpError(err);
    }
  }

  /**
   * Вариант Put + multipart/form-data
   * @param apiUrl
   * @param formData
   */
  const putFormData = async function (apiUrl: string, formData: FormData): Promise<{
    err?: string,
    data?: any
  }> {
    try {
      const {data} = await axios.put(`${PUBLIC_API_URL}/${apiUrl}`, formData, {
        headers: {
          ...authHeader,
          "Content-Type": "multipart/form-data"
        }
      })

      if (data.error) return {err: data.error}

      return {data}
    } catch (err: any) {
      return {err: err.message}
    }
  }

  /** Сохранение данные по user (пользователь, эксперт, организация)
   *  @param {string} apiUrl название api - без префикса / и без "api"
   */
  const put = async function (apiUrl: string, params: any = {}): Promise<{
    err?: string,
    data?: any,
  }> {
    try {
      const {data} = await axios.put(`${PUBLIC_API_URL}/${apiUrl}`, params, {
        paramsSerializer: serializer,
        headers: {
          ...authHeader
        }
      });

      return {data};
    } catch (e: any) {
      console.trace(e.message);
      return {err: e.message}
    }
  }

  /** Сохранение данные по user (пользователь, эксперт, организация)
   *  @param {string} apiUrl название api - без префикса / и без "api"
   */
  const del = async function (apiUrl: string): Promise<{
    err?: string,
    data?: any,
  }> {
    try {
      const {data} = await axios.delete(`${PUBLIC_API_URL}/${apiUrl}`, {
        headers: {
          ...authHeader
        }
      });

      return {data};
    } catch (e: any) {
      console.trace(e.message);
      return {err: e.message}
    }
  }

  return {
    get,
    post,
    postFormData,
    putFormData,
    put,
    del,
  }
}
